import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftItem,
  GiftItemBulkCreate,
  GiftItemBulkCreateResult,
  GiftItemCreate,
  GiftItemUpdate,
} from './giftItem.interface';

export const getGiftItemList = async (role: LowerRole, bugoBrandId?: string) => {
  const filter = bugoBrandId ? `&filter={"bugoBrand":"${bugoBrandId}"}` : '';
  const { data } = await api_.get<GiftItem[]>(
    `${role}/gift-item?populate=[{"path":"giftItemInfo","populate":["image"]},{"path":"bugoBrand"},{"path":"image"}]${filter}`,
  );
  return data;
};

export const getGiftItemListByBugoBrand = async (
  bugoBrandId: string,
  role: LowerRole,
) => {
  const { data } = await api_.get<GiftItem[]>(
    `${role}/gift-item/by-bugo-brand?bugoBrand=${bugoBrandId}&populate=[{"path":"giftItemInfo","populate":["image","detailImages"]},{"path":"image"},{"path":"detailImages"}]`,
  );
  return data;
};

export const getGiftItem = async (id: string, role: LowerRole) => {
  const { data } = await api_.get<GiftItem>(
    `${role}/gift-item/${id}?populate=[{"path":"giftItemInfo","populate":["image","detailImages","deliveredImageList"]},{"path":"bugoBrand"},{"path":"image"},{"path":"detailImages"},{"path":"deliveredImageList"}]`,
  );
  return data;
};

export const createGiftItem = async (giftItem: GiftItemCreate, role: LowerRole) => {
  const { data } = await api_.post<GiftItem>(`${role}/gift-item`, giftItem);
  return data;
};

//* 브랜드 일괄 등록 — 서버가 중복·미존재·판매중지를 건너뛰고 나머지를 한 번에 insert
export const bulkCreateGiftItems = async (body: GiftItemBulkCreate, role: LowerRole) => {
  const { data } = await api_.post<GiftItemBulkCreateResult>(
    `${role}/gift-item/bulk`,
    body,
  );
  return data;
};

export const updateGiftItem = async (giftItem: GiftItemUpdate, role: LowerRole) => {
  const { data } = await api_.patch<GiftItem>(
    `${role}/gift-item/${giftItem._id}`,
    giftItem,
  );
  return data;
};

export const deleteGiftItem = async (id: string, role: LowerRole) => {
  const { data } = await api_.delete(`${role}/gift-item/${id}`);
  return data;
};
